import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { restorePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { store } from '../../common/redux/configure-store';
import { IOwnBagProps, showOwnBagContainer } from '../component/own-bag';
import { updateLineItemQuantity } from './service/handle-update-quantity';

export const handleOwnBag = (): void => {
  const ownBagConfiguration = store.getState().touchPoint.touchPointConfiguration
    .ownBagConfiguration;

  const onKeypadSubmit = async (quantity: number) => {
    if (quantity < 0) {
      onCancel();
    } else {
      const inputData: IItemInputData = {
        itemId: ownBagConfiguration?.productId,
        quantity,
      };

      return withSpinner(() =>
        updateLineItemQuantity(inputData)
          .catch(popupMessage)
          .finally(onCancel),
      );
    }
  };

  const props: IOwnBagProps = {
    onCancel: onCancel,
    onKeypadSubmit,
  };

  showOwnBagContainer(props);
};

const onCancel = (): void => restorePage();
